"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReviewAttributeColumnManager = void 0;
const react_1 = require("react");
const utils_1 = require("./utils");
const table_columns_1 = require("../../common/table-columns");
const useReviewAttributeColumnManager = ({ persistedData: productsTableConfig, setPersistedData, defaultReviewAttributeIndex = table_columns_1.BASE_COLUMNS.length, }) => {
    const addReviewAttributeColumn = (0, react_1.useCallback)((config, columnId) => {
        const { columnsOrder } = config;
        const isColumnSelected = (0, utils_1.checkIsColumnSelected)(columnId, config);
        const currentIndex = columnsOrder.findIndex((id) => id === columnId);
        const newExcludedColumns = (0, utils_1.selectColumn)(columnId, config);
        // place column right after the default fields
        const newColumnsOrder = (0, utils_1.changeColumnOrder)(columnId, { columnsOrder, targetIndex: defaultReviewAttributeIndex });
        const reviewAttributePreviousIndex = isColumnSelected ? currentIndex : undefined;
        return {
            excludedColumns: newExcludedColumns,
            columnsOrder: newColumnsOrder,
            reviewAttribute: {
                id: columnId,
                previousIndex: reviewAttributePreviousIndex,
            },
        };
    }, [defaultReviewAttributeIndex]);
    const removeReviewAttributeColumn = (0, react_1.useCallback)((config, columnId) => {
        const { reviewAttribute, columnsOrder } = config;
        const columnIdToRemove = columnId || (reviewAttribute === null || reviewAttribute === void 0 ? void 0 : reviewAttribute.id);
        if (!columnIdToRemove) {
            return {};
        }
        const { id: reviewAttributeId, previousIndex } = reviewAttribute !== null && reviewAttribute !== void 0 ? reviewAttribute : {};
        const isNewlyAddedColumn = !Number.isInteger(previousIndex);
        if (reviewAttributeId !== columnIdToRemove) {
            return {};
        }
        const isReviewAttributeColumnSelected = (0, utils_1.checkIsColumnSelected)(columnIdToRemove, config);
        if (!isReviewAttributeColumnSelected) {
            return {};
        }
        const currentIndex = columnsOrder.findIndex((id) => id === columnIdToRemove);
        const isInitialColumnPosition = currentIndex === defaultReviewAttributeIndex;
        const newExcludedColumns = isNewlyAddedColumn && isInitialColumnPosition
            ? (0, utils_1.deselectColumn)(columnIdToRemove, config)
            : config.excludedColumns;
        const columnsOrderWithoutReviewAttribute = isNewlyAddedColumn && isInitialColumnPosition
            ? (0, utils_1.removeFromColumnsOrder)(columnIdToRemove, { columnsOrder })
            : columnsOrder;
        const newColumnsOrder = !isNewlyAddedColumn && isInitialColumnPosition
            ? (0, utils_1.changeColumnOrder)(columnIdToRemove, { columnsOrder: columnsOrderWithoutReviewAttribute, targetIndex: previousIndex })
            : columnsOrderWithoutReviewAttribute;
        // if the column has already been moved -> do nothing
        return {
            excludedColumns: newExcludedColumns,
            columnsOrder: newColumnsOrder,
            reviewAttribute: undefined,
        };
    }, [defaultReviewAttributeIndex]);
    const onToggleReviewAttributeColumn = (0, react_1.useCallback)((columnId) => {
        const updatedData = removeReviewAttributeColumn(productsTableConfig);
        const newData = addReviewAttributeColumn(Object.assign(Object.assign({}, productsTableConfig), updatedData), columnId);
        setPersistedData(Object.assign(Object.assign({}, updatedData), newData));
    }, [addReviewAttributeColumn, productsTableConfig, removeReviewAttributeColumn, setPersistedData]);
    const onAddReviewAttributeColumn = (0, react_1.useCallback)((columnId) => {
        const updatedData = addReviewAttributeColumn(productsTableConfig, columnId);
        setPersistedData(updatedData);
    }, [addReviewAttributeColumn, productsTableConfig, setPersistedData]);
    const onRemoveReviewAttributeColumn = (0, react_1.useCallback)((columnId) => {
        const updatedData = removeReviewAttributeColumn(productsTableConfig, columnId);
        setPersistedData(updatedData);
    }, [productsTableConfig, removeReviewAttributeColumn, setPersistedData]);
    const onResetReviewAttributeColumn = (0, react_1.useCallback)(() => {
        const updatedData = removeReviewAttributeColumn(productsTableConfig);
        setPersistedData(updatedData);
    }, [productsTableConfig, removeReviewAttributeColumn, setPersistedData]);
    return {
        onToggleReviewAttributeColumn,
        onAddReviewAttributeColumn,
        onRemoveReviewAttributeColumn,
        onResetReviewAttributeColumn,
    };
};
exports.useReviewAttributeColumnManager = useReviewAttributeColumnManager;
